import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import styles from '../OrderShortedLinesTable/OrderShortedLinesTable.module.scss';

function calculateOrderLinesRows(order) {
  return order.order_lines.map((orderLine) => ({
    id: orderLine.id,
    variant_id: orderLine.variant_id,
    title: orderLine.variant?.title,
    sku: orderLine.variant?.sku,
    upc: orderLine.variant?.upc || 'N/A',
    ordered: orderLine.original_quantity,
  }));
}

function AutoCancelledOrderLinesTable(props) {
  if (!props.order) {
    return null;
  }

  const orderLinesRows = calculateOrderLinesRows(props.order);
  if (!orderLinesRows.length) {
    return null;
  }

  const columns = [
    {
      text: 'Title',
      dataField: 'title',
    },
    {
      text: 'SKU',
      dataField: 'sku',
    },
    {
      text: 'Upc',
      dataField: 'upc',
    },
    {
      text: 'Ordered',
      dataField: 'ordered',
    },
  ];

  return (
    <div className={styles.shortedLines}>
      <hr />
      <h3 data-testid="title">Order Lines</h3>

      <BootstrapTable
        data={orderLinesRows}
        columns={columns}
        keyField="id"
        striped
        bordered={false}
        hover
      ></BootstrapTable>
    </div>
  );
}

export default AutoCancelledOrderLinesTable;
